// 通过环境变量 VUE_APP_BUILD_TYPE 区分：TEST=测试服 PRODUCTION=正式服 IRAQ=伊拉克服
// npm run build → 测试服  npm run build:prod → 正式服
const type = process.env.VUE_APP_BUILD_TYPE || 'TEST'

/**
 * 2024.10.16号新增伊拉克域名，伊拉克用户访问不到Production的域名
 * 后续更新正式服的时候需要更新两个，Production和Iraq
 * IRAQ构建的包叫 agent_manage_aws 
 *  */

let httpUrl,
  admHttpUrl = ''
switch (type) {
  // 测试服
  case 'TEST':
    httpUrl = 'https://testvideochat.kissu.site'
    admHttpUrl = 'http://test.kissu.site:18080'
    break
  case 'IRAQ':
    httpUrl = 'https://videochat.fusum.net'
    admHttpUrl = 'https://videochat.fusum.net'
    break
  // 正式服
  case 'PRODUCTION':
    httpUrl = 'https://videochat.kissu.site'
    admHttpUrl = 'https://www.kissu.site'
    break
}

// Http Url
export const CINFIG_HTTPURL = httpUrl

// Http admin Url
export const CINFIG_HTTPURL_ADMIN = admHttpUrl

// 全局变量 钻石倍率 cr，默认值为 5
export const cr = 5
